import { Box, FormControl, DialogTitle as MuiDialogTitle, Skeleton, styled, Typography } from '@mui/material';
import Dialog from '@mui/material/Dialog';

export const StyledDialog = styled(Dialog)(({ theme }) => ({
  '& .MuiDialog-paper': {
    padding: theme.spacing(3),
  },
  '& .MuiSelect-select': {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
  '& .MuiOutlinedInput-root': {
    '& .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&:hover .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      border: 'none',
    },
  },
}));

export const StyledDialogTitle = styled(MuiDialogTitle)(({ theme }) => ({
  fontSize: theme.typography.h2.fontSize,
  fontWeight: theme.typography.h2.fontWeight,
  color: theme.palette.primary.main,
}));

export const StyledProgressContainer = styled(Box)(({ theme }) => ({
  width: '100%',
  marginBottom: theme.spacing(2),
}));

export const StyledSkeletonContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

export const StyledSkeleton = styled('div')(({ theme }) => ({
  marginBottom: theme.spacing(2),
  '&:last-child': {
    marginBottom: 0,
  },
}));

export const StyledRectangle = styled(Skeleton)(({ theme }) => ({
  height: 40,
  borderRadius: theme.shape.borderRadius,
}));

export const StyledRadioText = styled(Typography)(({ theme }) => ({
  fontSize: theme.typography.h3.fontSize,
  fontWeight: theme.typography.h3.fontWeight,
  color: theme.palette.primary.dark,
}));

export const StyledRadioContainer = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.grey[300]}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.common.white,
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
}));

export const StyledRadioRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(2),
}));

export const StyledSubOptionsContainer = styled(Box)(({ theme }) => ({
  marginLeft: theme.spacing(4),
  marginBottom: theme.spacing(2),
}));

export const StyledCheckboxRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  marginBottom: theme.spacing(1),
}));

export const StyledFormControl = styled(FormControl)(() => ({
  minWidth: 200,
}));

export const StyledContentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-start',
  gap: theme.spacing(2),
}));

export const StyledInfoIcon = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(0.5),
  flexShrink: 0,
}));
